module.exports = __webpack_public_path__ + "static/media/reactlogo2.fdacb664.png";